export const regexCellPhoneUser = /^\(\d{2}\) \d{5} \d{4}$/
export const regexCellPhoneCompany = /^\(\d{2}\) \d{4,5} \d{4}$/
